import React from "react";
import { motion } from "framer-motion";
import { Users, Trophy, Star, Heart } from "lucide-react";
import AnimatedSection from "./AnimatedSection";


const HeroSection = () => {
    return (
        <section className="relative py-32 overflow-hidden">
            {/* Team Photo Background with Overlay */}
            <div className="absolute inset-0">
                <motion.div
                    initial={{ scale: 1.1, opacity: 0 }}
                    whileInView={{ scale: 1, opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 1.5 }}
                    className="absolute inset-0"
                >
                    {/* <img
                        src={equipePhoto}
                        alt="Notre Équipe Myriade"
                        className="w-full h-full object-cover"
                        style={{ objectPosition: 'center top' }}
                    /> */}
                    {/* <div className="absolute inset-0 bg-linear-to-b from-black/80 via-black/70 to-black/90" />
                    <div className="absolute inset-0 bg-linear-to-r from-blue-900/40 via-transparent to-purple-900/40" /> */}
                </motion.div>
            </div>

            <div className="relative z-10 max-w-7xl mx-auto px-4">
                <AnimatedSection delay={0.2}>
                    <div className="text-center mb-12">
                        <div className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-blue-500/10 backdrop-blur-md border border-blue-500/20 mb-8">
                            <Users className="w-5 h-5 text-blue-400" />
                            <span className="text-blue-300 font-medium">Notre Force</span>
                        </div>

                        <h2 className="text-4xl sm:text-5xl md:text-7xl font-bold text-white mb-6">
                            Notre<span className="bg-gradient-to-r from-blue-400 via-cyan-300 to-blue-600 bg-clip-text text-transparent px-2 sm:px-4">Équipe</span>
                        </h2>

                        <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
                            Des experts passionnés qui transforment vos défis en succès technologiques
                        </p>
                    </div>
                </AnimatedSection>

                <AnimatedSection delay={0.4}>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-5xl mx-auto">
                        {[
                            { value: "6", label: "Experts", icon: Users, color: "from-blue-500 to-cyan-500" },
                            { value: "8+", label: "Années d'expérience", icon: Trophy, color: "from-emerald-500 to-green-500" },
                            { value: "100+", label: "Projets réalisés", icon: Star, color: "from-purple-500 to-pink-500" },
                            { value: "88%", label: "Satisfaction client", icon: Heart, color: "from-amber-500 to-orange-500" }
                        ].map((stat, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: index * 0.1, duration: 0.6 }}
                                whileHover={{ scale: 1.05 }}
                                className="relative group"
                            >
                                <div className="relative bg-gray-900/70 backdrop-blur-xl rounded-2xl p-4 md:p6 border border-gray-700/50 text-center">
                                    <div className={`w-10 h-10 md:h-12 md:w-12 mx-auto mb-4 rounded-xl bg-linear-to-r ${stat.color} flex items-center justify-center`}>
                                        <stat.icon className="w-4 h-4 md:w-6 md:h-6 text-white" />
                                    </div>
                                    <div className="text-2xl md:text-4xl font-bold text-white mb-2">{stat.value}</div>
                                    <div className="text-[10px] md:text-sm  text-gray-400">{stat.label}</div>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </AnimatedSection>
            </div>
        </section>
    );
};

export default HeroSection;
